/**
 * Le numéro de bon de commande du client.
 *
 * <p>Une société qui commande du matériel donne son numéro de bon de
 * commande ; elle ne paie que la facture qui le porte. Il s'écrit sur l'offre
 * ou la facture, s'imprime en vue sous le titre (« Votre bon de commande :
 * … »), et suit de l'offre à la facture. La fiche du client dit s'il l'exige :
 * la facture ne part pas sans lui.
 */

/** Clé de la condition de la fiche client. */
export const CLE_EXIGE_BON_COMMANDE = 'exigeBonCommande';

/**
 * Vrai quand le client exige un numéro de bon de commande.
 *
 * @param {object} [client] fiche du client
 * @returns {boolean} il l'exige
 */
export function exigeBonCommande(client) {
  return client?.cond?.[CLE_EXIGE_BON_COMMANDE] === 'oui';
}

/**
 * Vrai quand la pièce n'a pas le numéro que son client exige.
 *
 * @param {object} piece offre ou facture
 * @param {object} [client] fiche du client
 * @returns {boolean} il manque
 */
export function manqueBonCommande(piece, client) {
  return exigeBonCommande(client) && !String(piece?.commandeClient ?? '').trim();
}

/**
 * La fiche du client, avec ou sans l'exigence.
 *
 * @param {object} client fiche du client
 * @param {boolean} exige il l'exige
 * @returns {object} la fiche à jour
 */
export function avecExigence(client, exige) {
  return {
    ...client,
    cond: { ...(client.cond || {}), [CLE_EXIGE_BON_COMMANDE]: exige ? 'oui' : '' },
  };
}

/** Ce que l'écran dit quand la facture part sans le numéro exigé. */
export const MSG_BON_COMMANDE =
  'Ce client exige un n° de bon de commande. Ajoutez-le à la facture avant de l’envoyer : sans lui, elle ne sera pas payée.';
